import { useRef, useState, useEffect, useImperativeHandle, forwardRef } from 'react';
import type { ReactNode } from 'react';
import { Box, Menu, ButtonBase } from '@mui/material';

interface BaseNavbarPopoverProps {
  children?: ReactNode;
  anchorEl?: ReactNode;
  isPopover?: boolean;
  title?: any;
  id?: string;
  isOpen?: boolean;
  onClose?: () => void;
}

const BaseNavbarPopover = forwardRef((props: BaseNavbarPopoverProps, ref) => {
  const anchorRef = useRef<HTMLButtonElement | null>(null);
  const [open, setOpen] = useState<boolean>(false);

  useEffect(() => {
    setOpen(false);
  }, [props.isOpen]);

  useImperativeHandle(ref, () => ({
    closeMenu() {
      setOpen(false);
    },
  }));

  const handleOpen = (): void => {
    setOpen(true);
  };

  const handleClose = (): void => {
    setOpen(false);
  };

  if (props.isPopover) {
    return (
      <>
        <ButtonBase title={props.title} onClick={handleOpen} ref={anchorRef} id={props.id} disableRipple>
          {props.anchorEl}
        </ButtonBase>

        <Menu
          anchorEl={anchorRef.current}
          anchorOrigin={{
            horizontal: 'left',
            vertical: 'bottom',
          }}
          keepMounted
          onClose={handleClose}
          open={open}
          className="global-nav__dropdown"
          onKeyDown={(e) => e.stopPropagation()}
        >
          <Box className="global-nav__dropdown__items">{props.children}</Box>
        </Menu>
      </>
    );
  } else {
    return <>{props.children}</>;
  }
});

export default BaseNavbarPopover;
